import React, { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { GameContext } from "../../shared/GameContext";
import Lobby from "../../shared/api/LobbyApi";

interface GameContextProps {
  children: ReactNode;
}

export default function GameContextProvider(props: GameContextProps) {
  const [name, setName] = useState("");
  const [lobbyKey, setLobbyKey] = useState("");
  const history = useHistory();

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith("/lobby")) return; // already in lobby
    const REDIRECT_PATHS = ["/", "/play", "/join"];
    if (!REDIRECT_PATHS.includes(path)) return; // don't redirect on other pages (e.g. deck-tutorial opened in new tab)
    const storedPlayerId = sessionStorage.getItem("playerId");
    if (!storedPlayerId) return; // no tab-specific session, nothing to restore
    Lobby.sessionLobby(storedPlayerId).then((result) => {
      if (result?.hasActiveLobby && result.lobbyKey) {
        setLobbyKey(result.lobbyKey);
        history.push("/lobby");
      }
    });
  }, []);

  const value = useMemo(
    () => ({ nameState: name, setNameState: setName, lobbyKey, setLobbyKey }),
    [name, lobbyKey]
  );

  return (
    <GameContext.Provider value={value}>
      {props.children}
    </GameContext.Provider>
  );
}
